import { useSourceOfDataQuery } from "queries";

const useSourceOfDataColumn = () => {
	const { data: sourceOfData } = useSourceOfDataQuery();
	return {
		name: "sourceOfData",
		type: "select" as const,
		loadOptions: search => {
			return {
				options: sourceOfData?.filter(item =>
					item?.displayName
						?.toLowerCase()
						?.includes(search?.toLowerCase()),
				),
				hasMore: false,
			};
		},
		getOptionLabel: option => option.displayName,
		getOptionValue: option => option.value,
		placeholder: "Source of Data",
	};
};

export default useSourceOfDataColumn;
